const c = [
  "shell/curl",
  "ruby/native",
  "node/undici",
  "php/guzzle",
  "python/python3"
], i = (t, n = c) => !!(t && n.includes(t)), r = (t, n = c) => {
  const s = /* @__PURE__ */ new Map();
  for (const o of t)
    for (const e of o.options)
      s.set(e.id, e);
  return n.flatMap((o) => s.get(o) ?? []);
};
export {
  r as getFeaturedClients,
  i as isFeaturedClient
};
